export const MONSTA_BODY_PARTS_TOOLTIP =
  "Displays the unique body parts of this Monsta. Each body parts correlates to a unique attribute that determines your Monsta’s overall attributes, stats and skills.";
export const WEBGL_MONSTA_OBJECT = "MonstaLoader";
export const WEBGL_SOURCE_URL = "/WebglAnimation";
